import Vue from 'vue'

import Notification from './notification'
import ConfirmDialog from './confirm'
import StatusChip from './status-chip'
import DateDialog from './date-dialog'
import TimeDialog from './time-dialog'

Vue.component('Notification', Notification)
Vue.component('ConfirmDialog', ConfirmDialog)
Vue.component('StatusChip', StatusChip)
Vue.component('DateDialog', DateDialog)
Vue.component('TimeDialog', TimeDialog)
